var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgToggleOff = function SvgToggleOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 33 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.281 0H23.72C28.836 0 33 4.262 33 9.5S28.836 19 23.719 19H9.28C4.164 19 0 14.738 0 9.5S4.164 0 9.281 0Zm0 16.889a7.101 7.101 0 0 0 4.01-1.245 7.355 7.355 0 0 0 2.66-3.316 7.55 7.55 0 0 0 .41-4.27 7.444 7.444 0 0 0-1.975-3.783 7.169 7.169 0 0 0-3.696-2.022 7.065 7.065 0 0 0-4.171.42 7.258 7.258 0 0 0-3.24 2.722A7.513 7.513 0 0 0 2.063 9.5a7.486 7.486 0 0 0 2.116 5.222 7.143 7.143 0 0 0 5.102 2.167Z"
  })));
};
export default SvgToggleOff;